// css
import '../../scss/pages/single-blog.scss';

// utils
import Foundation from '../_utils/foundation';
Foundation();

// libs
import Accordion from '../_libs/Accordion';
import { Modal } from '../_libs/Modal';
import AnchorScroll from '../_libs/AnchorScroll';

document.addEventListener('DOMContentLoaded', () => {
	Accordion({
		base: '.js-accordion-archives',
		trigger: '.js-accordion-archives-trigger',
		target: '.js-accordion-archives-target',
		option: false,
	});
	if (!window.matchMedia('(min-width: 768px)').matches) {
		Accordion({
			base: '.js-accordion-breadcrumbs',
			trigger: '.js-accordion-breadcrumbs-trigger',
			target: '.js-accordion-breadcrumbs-target',
			option: false,
		});
	}

	const menuModal = new Modal({
		modal: '.js-menu',
		open: '.js-menu-button',
		close: '.js-close-button',
		html: 'menu-open',
		globalContainer: '.js-main',
		overlay: '.js-modal-overlay',
	});

	menuModal.init();

	//目次用のスクロール
	handleAnchorScroll();

	// シェア

	const share_url = encodeURIComponent(location.href);
	const share_title = encodeURIComponent(document.title);

	// Facebook share buttons
	const facebook_buttons = document.querySelectorAll('.js-share-facebook');
	facebook_buttons.forEach((button) => {
		button.setAttribute(
			'href',
			'https://www.facebook.com/share.php?u=' + share_url
		);
	});

	const twitter_buttons = document.querySelectorAll('.js-share-twitter');
	twitter_buttons.forEach((button) => {
		button.setAttribute(
			'href',
			'https://twitter.com/intent/tweet?url=' +
				share_url +
				'&text=' +
				share_title
		);
	});

	const line_buttons = document.querySelectorAll('.js-share-line');
	line_buttons.forEach((button) => {
		button.setAttribute(
			'href',
			'https://social-plugins.line.me/lineit/share?url=' + share_url
		);
	});

	// URLコピー
	const copyBtn = document.getElementById('copy-url');
	copyBtn.addEventListener('click', () => {
		copyUrl();
	});
});

window.addEventListener('load', () => {});

window.addEventListener('resize', handleAnchorScroll);

function handleAnchorScroll() {
	const element = document.querySelector('.js-mokukji-anchor-scroll');
	if (!element) return;

	const offset = window.innerWidth <= 768 ? 145 : 0;
	AnchorScroll('.js-mokukji-anchor-scroll', offset);
}

function copyUrl() {
	//コピーしたいテキストを持つ要素を取得
	let currentURL = location.href;

	//ブラウザの対応状況で分岐
	if (navigator.clipboard) {
		//クリップボードにコピーを実行
		navigator.clipboard.writeText(currentURL).then(
			function () {
				//コピーに成功したときの処理
				console.log('copied.');
				document.getElementById('js-change-text').textContent =
					'コピーしました！';
			},
			function () {
				//コピーに失敗したときの処理...
				console.log('clipboard denied.');
			}
		);
	} else if (document.execCommand) {
		//「input」要素を生成して属性値とstyleを設定
		let inputEle = document.createElement('input');
		inputEle.setAttribute('type', 'text');
		inputEle.setAttribute('value', currentURL);
		inputEle.style.position = 'fixed';
		inputEle.style.left = '-100%';
		//「input」要素をbody内に挿入
		document.body.appendChild(inputEle);
		//テキストを選択状態にする
		inputEle.select();
		//コピーを実行
		let execResult = document.execCommand('copy');
		//「input」要素を削除
		inputEle.parentNode.removeChild(inputEle);
		//結果をコンソールに表示
		console.log('execCommand : ' + execResult);
		document.getElementById('js-change-text').textContent =
			'コピーしました！';
	} else {
		//クリップボードにアクセスできなかった場合の処理
		console.log('Can not copy. No permission and execCommand died.');
	}
}
